/* eslint react-hooks/exhaustive-deps: "warn" */

import styles from './CompanyVerificationCard.module.scss';

const ROWS = [
  {
    delay: '0.88s',
    color: '#137A3D',
    status: 'Active',
    title: 'Legal identity & status',
    desc: 'Verified against the registry of record',
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3l7 3v5c0 4.2-2.9 6.7-7 8-4.1-1.3-7-3.8-7-8V6l7-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    delay: '1.636s',
    color: '#2945FF',
    status: 'Resolved',
    title: 'Beneficial ownership',
    desc: 'Ultimate owners resolved to individuals',
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="8" r="3.4" />
        <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
      </svg>
    ),
  },
  {
    delay: '2.392s',
    color: '#137A3D',
    status: 'No match',
    title: 'Sanctions & PEP screening',
    desc: 'Company and its owners screened',
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3l6 8.2A6 6 0 1 1 6 11.2L12 3z" />
      </svg>
    ),
  },
  {
    delay: '3.148s',
    color: '#137A3D',
    status: 'Stable',
    title: 'Financial health',
    desc: 'Filed accounts & modelled figures',
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 20V13" />
        <path d="M12 20V8" />
        <path d="M18 20v-4" />
      </svg>
    ),
  },
  {
    delay: '3.904s',
    color: '#B26F0E',
    status: '3 linked',
    title: 'Corporate group',
    desc: 'Parent, subsidiaries & shared owners',
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="6" r="2.3" />
        <circle cx="6" cy="18" r="2.3" />
        <circle cx="18" cy="18" r="2.3" />
        <path d="M11 7.6L7 16.4M13 7.6l4 8.8M7.4 18h9.2" />
      </svg>
    ),
  },
];

export const CompanyVerificationCard = () => (
  <div
    className={styles.card}
    role="img"
    aria-label="Live supplier verification: Meridian Components Ltd (SAMPLE) — legal identity Active, beneficial ownership Resolved, sanctions and PEP No match, financials Stable, corporate group 3 linked; overall risk Low, monitored."
  >
    <span className={styles.scanLine} aria-hidden="true" />

    <div className={styles.head}>
      <div className={styles.badge}>GB</div>

      <div className={styles.identity}>
        <div className={styles.companyName}>Meridian Components Ltd</div>

        <div className={styles.tags}>
          <span className={`${styles.tag} ${styles.active}`}>Active</span>
          <span className={`${styles.tag} ${styles.sample}`}>Sample</span>
        </div>

        <div className={styles.source}>Companies House · United Kingdom</div>
      </div>

      <div className={styles.riskScore}>
        <div className={styles.riskValue}>Low</div>
        <div className={styles.riskLabel}>Risk profile</div>
      </div>
    </div>

    <div className={styles.track}>
      <span className={styles.trackFill} aria-hidden="true" />
    </div>

    <ul className={styles.rows}>
      {ROWS.map((row) => (
        <li
          key={row.title}
          className={styles.row}
          style={{ '--row-delay': row.delay, '--row-color': row.color } as React.CSSProperties}
        >
          <span className={styles.rowIcon}>{row.icon}</span>

          <span className={styles.rowText}>
            <span className={styles.rowTitle}>{row.title}</span>
            <span className={styles.rowDesc}>{row.desc}</span>
          </span>

          <span className={styles.rowStatus}>
            <span className={styles.statusDot} />
            {row.status}
          </span>
        </li>
      ))}
    </ul>

    <div className={styles.footer}>
      <span className={styles.monitored}>
        <span className={styles.monitoredDot} />
        Monitored
      </span>

      <span>Retrieved 2026-07-17T09:41:02Z</span>
    </div>
  </div>
);
